/* eslint-disable @typescript-eslint/no-explicit-any */
/**
 * @copyright (C) 2023, rsupport. All rights reserved
 *
 * @license
 * This software and/or source code may be used, copied and/or disseminated only
 * with the written permission of rsupport, or in accordance with the terms
 * and conditions stipulated in the agreement/contract under which the software
 * and/or source code has been supplied by rsupport or its affiliates.
 * Unauthorized use, copying, or dissemination of this file, via any medium, is
 * strictly prohibited, and will constitute an infringement of copyright.
 *
 * @author
 * Jinhyoung Jang (jangjh@rsupport.com)
 *
 * @description
 *
 * @created at Tue Dec 19 2023
 **/

import Heap from "./heap";

export default class PriorityQueue<T = any> extends Heap<T> {
	constructor() {
		super();
	}

	enqueue = (priority: number, value: T) => this.insert(priority, value);
	dequeue = () => this.remove();
	get is_empty() {
		return this._heap.length <= 0;
	}
}
